import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter
} from '@angular/core';

// @ts-ignore
@Component({
	selector: 'vtr-widget-switch-icon',
	templateUrl: './widget-switch-icon.component.html',
	styleUrls: ['./widget-switch-icon.component.scss']
})
export class WidgetSwitchIconComponent implements OnInit {
	@Input() title: string;
	@Input() iconDefinition: string;
	@Input() value = false;
	@Input() isBlocked = false;
	@Input() disable = false;
	@Input() isLoading = true;
	@Input() switchId: string;

	@Output() toggle = new EventEmitter<boolean>();

	constructor() { }

	ngOnInit() {
	}

	onChange(event: any) {
		if (!this.disable && !this.isLoading) {
			this.toggle.emit(event.switchValue);
		}
	}
}
